export default __webpack_public_path__ + "static/media/Beast Mantle of Bone and Horn.8b20c1b1.jpg";